<template>
  <div id="pageTitleMobile">
    <!-- TITLE -->
    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <h2>{{ title }}</h2>

          <!--POSITION, CONTACT (ONLY ON TEAM PAGES) -->
          <div v-if="position" v-html="newLineText(position)" class="position-kontakt"></div>
          <div v-if="kontakt" v-html="newLineText(kontakt)" class="space-ba-l"></div>
        </b-col>
      </b-row>
    </b-container>

    <!-- BACK LINK-->
    <div class="back-link">
      <router-link class="type-xs" :to="'/'"
        >← Basel Academy</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "PageTitleDesktop",
  props: {
    title: String,
    position: String,
    kontakt: String,
  },
  methods: {
    newLineText(el) {
      if (el) {
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  padding-top: 0.8rem;
  padding-bottom: 1.4rem;
}
@media (min-width: 768px) {
  h2 {
    padding-top: 1.8rem;
    padding-bottom: 1.4rem;
  }
}

.position-kontakt {
  padding-bottom: 3rem;
}

.team-bild {
  width: 66.6666%;
  padding-bottom: 3rem;
}

.back-link {
  position: fixed;
  background-color: white;
  z-index: 10;
  width: 100%;
  bottom: 0;
  padding: 1rem 1.5rem;
  & a {
    display: block;
  }
}
</style>